import React, { ReactNode } from 'react'
import { Link, Route } from 'react-router-dom'

import { NavLink } from '~/components'

import * as routes from '~/pages/routes'
import { auth, isAuthenticated } from '~/firebase'

import './style.css'


interface HeaderNavLinkProps {
  children: ReactNode,
  exact?: boolean,
  to: string
}

function HeaderNavLink({children, ...linkProps}: HeaderNavLinkProps) {
  return (
    <NavLink {...linkProps}>
      {({active}) => (
        <Link to={linkProps.to} className={`headerNavLink ${active ? 'active' : ''}`}>
          {children}
        </Link>
      )}
    </NavLink>
  )
}


export default function Navigation({basket: {length: basket}, orders: {length: orders}}: {basket: string[], orders: any[]}) {
  return (
    <div className="sc-gZMcBi jKFWHL" data-rtl="ltr">
      <div className="isomorphicTopbar ant-layout-header" style={{position: 'fixed', width: '100%', height: 70}}>
        <div className="isoLeft">
          <nav className="headerNav">
            <HeaderNavLink to={routes.LANDING} exact><i className="ion-paper-airplane"/>Landing</HeaderNavLink>
            <HeaderNavLink to={routes.DASHBOARD} exact><i className="ion-speedometer"/>Dashboard</HeaderNavLink>
            <HeaderNavLink to={routes.ACCOUNT} exact><i className="ion-lock-combination"/>Account</HeaderNavLink>
            <div className="verticalRule labeled">
              <div className="label">
                CONCEPTS
              </div>
            </div>
            <HeaderNavLink to={routes.DASHBOARD_MULTI} exact><i className="ion-speedometer"/>Multi</HeaderNavLink>
            <HeaderNavLink to={routes.DASHBOARD_SOLO} exact><i className="ion-speedometer"/>Solo</HeaderNavLink>
          </nav>
        </div>
        <div className="isoRight">
          <nav className="headerNav">
            <HeaderNavLink to={routes.ADMIN} exact><i className="ion-aperture"/>Admin</HeaderNavLink>
            <HeaderNavLink to={routes.DEVTOOLS.INDEX}><i className="ion-ionic" title="Dev tools"/>Dev tools</HeaderNavLink>
            <Route
            path={routes.DEVTOOLS.INDEX}
            render={() => (
              <ul>
                <li><HeaderNavLink to={routes.DEVTOOLS.API} exact>API</HeaderNavLink></li>
                <li><HeaderNavLink to={routes.DEVTOOLS.FONTS} exact>Fonts</HeaderNavLink></li>
              </ul>
            )}
            />
          </nav>
        </div>
        <ul className="isoRight">
          {/* <li className="isoNotify">
            <div className="isoIconWrapper">
              <i className="ion-android-notifications" title="Notifications"/><span>4</span></div>
          </li> */}
          <li className="isoCart">
            <div className="isoIconWrapper">
              <HeaderNavLink to={routes.BASKET.INDEX}>
                <i className="ion-android-cart" title={`${basket ? `${basket} item${basket > 1 ? 's' : ''} in ` : 'Empty '}Basket`}/>{!!basket && <span>{basket}</span>}
              </HeaderNavLink>
            </div>
          </li>
          <li className={`isoCart${orders ? ' visible' : ''}`} id="orderCart">
            <div className="isoIconWrapper">
              <HeaderNavLink to={routes.ORDERS}>
                <i className="ion-android-cart" title={`${orders} pending order${orders > 1 ? 's' : ''}`}/>
              </HeaderNavLink>
            </div>
          </li>
          <li className="isoUser">
            {
              isAuthenticated()
                ? <Link to="#" onClick={() => auth.signOut()} title={auth.currentUser!.email!}><i className="ion-log-out"/>Sign Out</Link>
                : <HeaderNavLink to={routes.SIGN_IN} exact><i className="ion-log-in"/>Sign In</HeaderNavLink>
            }
          </li>
        </ul>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Navigation/index.tsx